var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-agreement"},[_c('h1',[_vm._v("用户协议")]),_c('div',{staticClass:"agreement-content",domProps:{"innerHTML":_vm._s(_vm.agreementText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }